import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'

const TokenKey = 'Admin-Ja-Token'
const RememberPasswordKey = 'remember-password'
const RememberUsernameKey = 'remember-username'

/** Electron 打包后为 file://，Cookie 不可用，改走 localStorage */
function isFileProtocol() {
  try {
    return typeof location !== 'undefined' && location.protocol === 'file:'
  } catch (e) {
    return false
  }
}

export function getToken() {
  if (isFileProtocol()) {
    return localStorage.getItem(TokenKey) || ''
  }
  // Web / electron:dev(http)：优先 Cookie，兼容已写入 localStorage 的值
  return Cookies.get(TokenKey) || localStorage.getItem(TokenKey) || ''
}

export function setToken(token) {
  if (!token) {
    return removeToken()
  }
  // 始终写 localStorage，保证 file:// 与跨环境可读
  localStorage.setItem(TokenKey, token)
  if (!isFileProtocol()) {
    try {
      Cookies.set(TokenKey, token)
    } catch (e) {
      // ignore
    }
  }
  return token
}

export function removeToken() {
  localStorage.removeItem(TokenKey)
  try {
    Cookies.remove(TokenKey)
  } catch (e) {
    // ignore
  }
}

// 记住密码相关函数
export function getRememberPassword() {
  const encrypted = localStorage.getItem(RememberPasswordKey)
  if (!encrypted) return null
  try {
    // 使用 AES 解密
    const decrypted = CryptoJS.AES.decrypt(encrypted, 'remember-password-key').toString(CryptoJS.enc.Utf8)
    return decrypted || null
  } catch (error) {
    console.error('解密密码失败:', error)
    return null
  }
}

export function setRememberPassword(password) {
  if (!password) {
    localStorage.removeItem(RememberPasswordKey)
    return
  }
  // 使用 AES 加密
  const encrypted = CryptoJS.AES.encrypt(password, 'remember-password-key').toString()
  localStorage.setItem(RememberPasswordKey, encrypted)
}

export function getRememberUsername() {
  return localStorage.getItem(RememberUsernameKey) || ''
}

export function setRememberUsername(username) {
  if (!username) {
    localStorage.removeItem(RememberUsernameKey)
    return
  }
  localStorage.setItem(RememberUsernameKey, username)
}

export function clearRememberInfo() {
  localStorage.removeItem(RememberPasswordKey)
  localStorage.removeItem(RememberUsernameKey)
}
